/* =====================================================================
   UUGI v4 theme — shared UI enhancements
   • Scroll-to-top button (auto-injected, appears after scrolling down)
   Self-contained: no jQuery dependency. Safe to include on every v4 page.
   ===================================================================== */
(function () {
  if (window.__uugiV4UI) return;          // guard against double-include
  window.__uugiV4UI = true;

  function init() {
    /* ---------- styles ---------- */
    var css = '' +
      '.v4-totop{' +
      'position:fixed;right:clamp(16px,3vw,28px);bottom:clamp(16px,3vw,28px);z-index:900;' +
      'width:48px;height:48px;border-radius:50%;border:1px solid rgba(242,169,59,0.5);' +
      'display:inline-flex;align-items:center;justify-content:center;cursor:pointer;' +
      'background:linear-gradient(155deg,#0B1230,#1A2247);color:#F2A93B;' +
      'box-shadow:0 10px 28px -10px rgba(11,18,48,0.55);' +
      'opacity:0;visibility:hidden;transform:translateY(14px) scale(0.9);' +
      'transition:opacity .35s ease,transform .35s ease,visibility .35s,background .3s ease;' +
      '-webkit-tap-highlight-color:transparent;padding:0;}' +
      '.v4-totop.is-visible{opacity:1;visibility:visible;transform:translateY(0) scale(1);}' +
      '.v4-totop:hover{background:linear-gradient(155deg,#1A2247,#26305f);transform:translateY(-2px) scale(1.04);color:#F8C97A;}' +
      '.v4-totop:active{transform:translateY(0) scale(0.96);}' +
      '.v4-totop svg{width:20px;height:20px;display:block;}' +
      '.v4-totop:focus-visible{outline:2px solid #F2A93B;outline-offset:3px;}' +
      '@media (max-width:520px){.v4-totop{width:44px;height:44px;}}' +
      '@media print{.v4-totop{display:none !important;}}';
    var style = document.createElement('style');
    style.id = 'v4-ui-style';
    style.textContent = css;
    document.head.appendChild(style);

    /* ---------- button ---------- */
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'v4-totop';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M12 19V5M6 11l6-6 6 6" stroke="currentColor" stroke-width="1.8" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';
    document.body.appendChild(btn);

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });

    /* ---------- show / hide on scroll ---------- */
    var shown = false, ticking = false;
    function update() {
      ticking = false;
      var should = window.pageYOffset > 480;
      if (should !== shown) {
        shown = should;
        btn.classList.toggle('is-visible', should);
      }
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
